import { useMutation } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  Feature,
  RefundSaleToCreditInput,
  SaleClient,
} from 'src/WebApiController';

/**
 * Mutation hook to call POST /api/Sale/RefundSaleToCredit.
 * Refunds a sale amount (full or partial) to the buyer's internal credit balance.
 * No Adyen call — credit is applied instantly.
 *
 * Gated behind Feature.RetailSale (FF 725).
 */
export function useRefundToCredit() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError, showErrorDialog } = useClientLogContext();
  const hasRetailSaleFeature = useUserHasFeature(Feature.RetailSale);

  return useMutation({
    mutationFn: async (input: RefundSaleToCreditInput) => {
      if (!hasRetailSaleFeature) {
        throw new Error('RetailSale feature is not enabled');
      }

      return await new SaleClient(
        activeAccountWebClientConfig
      ).refundSaleToCredit(input);
    },
    onError: (error: ErrorTypes) => {
      trackError('SaleClient.refundSaleToCredit', error);
      showErrorDialog('SaleClient.refundSaleToCredit', error);
    },
  });
}
